module.exports = __webpack_public_path__ + "files/0e4c993c405b63702a693b9195f0c15e.png";